// extracted by mini-css-extract-plugin
module.exports = {"pickupLabel":"style_pickupLabel__6fpke"};